var zooomyTC=($js)=>{
    let shop= Shopify.shop;
    let $ = $js
     

      
        $js('body').on("click",'a',function(e){
          
            let cartClick = $(this).attr("href");
            
            if( typeof cartClick!="undefined" && cartClick.includes("/cart")){
                
               setTimeout(function(){
                 if($("cart-drawer .zooomyagreetoterms").length==0){
                     $("cart-drawer-disclosure").parent().before('<div class="zooomyagreetoterms"></div>');
                   }
                    zooomyFun.addCheckbox()
                },1000)
            }
        })

        $js('body').on("click",'button[name=add],button[name="minus"],button[name="plus"],a.cart-item__remove',function(e){
                
              console.log('%c Oh my heavens! ', 'background: #222; color: #bada55');
                  
                
                      
                     setTimeout(function(){
                       if($("cart-drawer .zooomyagreetoterms").length==0){
                           $("cart-drawer-disclosure").parent().before('<div class="zooomyagreetoterms"></div>');
                         }
                          zooomyFun.addCheckbox()
                      },3500)
                  
              })
          
    


        let stopCheckout=document.querySelector("button[name=checkout]")??document.querySelector("input[name=checkout]");
        if(stopCheckout){
           
               stopCheckout.addEventListener("mouseover",function(e){
               
                    if(zooomyFun.termsRequired()==true  && $("#zooomytermscheck:checked").length==0){
                       $(this).attr("type","button")
                    }else{

                        $(this).attr("type","submit")
                    }
                
               })
            stopCheckout.addEventListener("click",function(e){
                console.log($("#zooomytermscheck:checked").length,'....mouseover...',zooomyFun.termsRequired())
                 if(zooomyFun.termsRequired()==true && $("#zooomytermscheck:checked").length==0){
                    alert(zooomyFun.data.alert_text);
                     e.stopPropagation()
                     return false;
                 }
               
            })
        }


        $js("body").on("click",".cart>a.listening,.quantity-selector__button,.product-form__add-button,.QuantitySelector__Button,.quantity__button,cart-remove-button,.CartItem__Remove,.ajax-cart__item-remove,.js-quickview-trigger", function(){
            
            setTimeout(function(){
               
               if($("cart-drawer .zooomyagreetoterms").length==0){
                     $("cart-drawer-disclosure").parent().before('<div class="zooomyagreetoterms"></div>');
                   }
                    zooomyFun.addCheckbox()
            },2000)
            
        })

        
        async function postData(url = '', data = {},method="GET") {
            return $.ajax({
                type: method,
                url: url,
                data: data,
                dataType: "jsonp",
                jsonp: "jsonCode",
                async: "true",
                    success: function(res){
                    return res;
                }
            });
        }

        
        
        postData("https://zooomyapps.com/agree/ZooomyProAgreeTerms.php",{shop:shop}).then(res=>{
                zooomyFun.init(res)
        })
        var zooomyFun={
          data:{},
          addCheckbox:function(){
            if(this.data.enable_check=="disable"){
                return true;
            }
            let textcont='';
            if(this.data.choose_display=="with_link_color"){
                textcont=`<span><a href="${this.data.checkbox_link}" target="${this.data.open_link}">${this.data.checkbox_text} ${this.data.click_here_text}</a></span>`       
            }else if(this.data.choose_display=="with_link_no_color"){
                 textcont=`<span><a href="${this.data.checkbox_link}" target="${this.data.open_link}">${this.data.checkbox_text} ${this.data.click_here_text}</a></span>`  
            } else{
                textcont=`<span>${this.data.checkbox_text} <a href="${this.data.checkbox_link}" target="${this.data.open_link}">${this.data.click_here_text}</a></span>`
            }
            var inputCheck= `<input type="checkbox" value="true" id="zooomytermscheck" > ${textcont}`;
           $js(".zooomyagreetoterms").html(inputCheck);
          },
          clickShopifyPayment:function(){
            let $paymentOption=".shopify-cleanslate li";

            $js("body").on("click",$paymentOption,function(e){
                var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length>0){
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'auto' );
                }else{
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'none' );
                    alert(zooomyFun.data.alert_text);
                }
            })
            $js("body").on("click","#zooomytermscheck",function(){
                var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length>0){
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'auto' );
                }else{
                    $('.shopify-cleanslate li>div,.shopify-cleanslate li>iframe').css( 'pointer-events', 'none' );
                }
            })
          },
          buttonClick:function(){
               
                let clickAddEvent= '.shopify-payment-button,button[name=add],input[name=add],button[name=checkout],input[name=checkout], a.quick-cart__buy-now,.product-form__add-button,.cart__checkout-button';
             
                $js("body").on("click",clickAddEvent,function(e){
                  
                    if($(".zooomyagreetoterms").length==0){
                        
                    }else{
                    
                        if(zooomyFun.termsRequired()==true){
                            if($(this).parents("form").length>0){
                                if($(this).attr("name")=="add"){
                                    console.log("...1...")
                                    setTimeout(function(){
                                    
                                        $("#ajaxifyModal").find(".cart__policies").after('<div class="zooomyagreetoterms"></div>');
                                        if($(".mini-cart__button-container").find(".zooomyagreetoterms").length==0){
                                            $(".mini-cart__button-container").find(".zooomyagreetoterms").prepend('<div class="zooomyagreetoterms"></div>')
                                        }
                                        if($("#mini-cart").find(".zooomyagreetoterms").length==0){
                                            $("#mini-cart").find(".ajax-cart__final-details").after('<div class="zooomyagreetoterms"></div>');
                                        }
                                        zooomyFun.addCheckbox()
                                    },2000)
                                }
                                let getParents =$(this).parents("form");
                                if(getParents.find(".zooomyagreetoterms").length==0){
                                    return;
                                }
                                var termStatus=getParents.find("#zooomytermscheck");
        
                                if(termStatus.prop("checked")==true){
                                    $('.shopify-payment-button>div').css( 'pointer-events', 'auto' );
                                }else{
                                
                                    e.preventDefault()
                                    if(termStatus.length>0){
                                        $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                                        alert(zooomyFun.data.alert_text);
                                        e.stopPropagation()
                                    
                                    }
                                } 
                            }else{     
                        
                                var termStatus=$("#zooomytermscheck:checked");
                                if(termStatus.length>0){
                                    $('.shopify-payment-button>div').css( 'pointer-events', 'auto' );
                                }else{
                                
                                    e.preventDefault()
                            
                                    $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                                    alert(zooomyFun.data.alert_text);
                                
                                    e.stopPropagation()

                                
                                }
                            }
    
                        }
                    }    
                })
          },
          buyNow:function(){
             var clickEvent=".shopify-payment-button,li[data-testid='grid-cell'],div[data-testid='grid-cell']";
              $js("body").on('mouseover touchstart', clickEvent,function(e){
               
                    e.stopPropagation();
                    e.preventDefault();
                
                    var termStatus=$("#zooomytermscheck:checked");
                if(termStatus.length==0){
               
                    if($(this).find('iframe[class*="paypalLight"]').length > 0 ){
                        $('iframe[class*="paypalLight"]').css( 'pointer-events', 'none' );
                    } else if($(this).find('[data-testid="ShopifyPay-button"]').length > 0 ) {
                        $('[data-testid="ShopifyPay-button"]').css( 'pointer-events', 'none' );
                    }
                    else if($(this).find('[data-testid="PayPalInContext-button"]').length > 0 ) {
                        $('[data-testid="PayPalInContext-button"]').css( 'pointer-events', 'none' );
                    }  else if($(this).find('[data-testid="GooglePay-button"]').length > 0 ) {
                        $('[data-testid="GooglePay-button"]').css( 'pointer-events', 'none' );
                    } 
                    else if($(this).find('[data-testid="ApplePay-button"]').length > 0 ) {
                        $('[data-testid="ApplePay-button"]').css( 'pointer-events', 'none' );
                    } 
                    else if($(this).find('.additional-checkout-button form, .dynamic-checkout__content').length > 0 ) {
                        $('.additional-checkout-button form, .dynamic-checkout__content').css( 'pointer-events', 'none' );
                    }else if($(this).find('[data-shopify="payment-button"]').length > 0 ) {
                        $('[data-shopify="payment-button"]').css( 'pointer-events', 'none' );
                    } 
                   
                }else{
                    if($(this).find('iframe[class*="paypalLight"]').length > 0 ){
                        $('iframe[class*="paypalLight"]').css( 'pointer-events', 'auto' );
                    } else if($(this).find('[data-testid="ShopifyPay-button"]').length > 0 ) {
                        $('[data-testid="ShopifyPay-button"]').css( 'pointer-events', 'auto' );
                    }
                    else if($(this).find('[data-testid="PayPalInContext-button"]').length > 0 ) {
                        $('[data-testid="PayPalInContext-button"]').css( 'pointer-events', 'auto' );
                    }  else if($(this).find('[data-testid="GooglePay-button"]').length > 0 ) {
                        $('[data-testid="GooglePay-button"]').css( 'pointer-events', 'auto' );
                    } 
                    else if($(this).find('[data-testid="ApplePay-button"]').length > 0 ) {
                        $('[data-testid="ApplePay-button"]').css( 'pointer-events', 'auto' );
                    } 
                    else if($(this).find('.additional-checkout-button form, .dynamic-checkout__content').length > 0 ) {
                        $('.additional-checkout-button form, .dynamic-checkout__content').css( 'pointer-events', 'auto' );
                    }  
                    
                }
                  //$(this).attr("disabled",true)   
  
              })

          },
          termsChecked:function(){
            $("body").on("click","#zooomytermscheck",function(e){
                  
                  if($(this).prop("checked")){
                      //$("input[name = 'checkout'], button[name = 'checkout'], #checkout, input[value='checkout'], input[value='Checkout'], input[value='Check out'], input[value='Check Out']").prop('disabled', false);
                       
                  }else{
                      //$("input[name = 'checkout'], button[name = 'checkout'], #checkout, input[value='checkout'], input[value='Checkout'], input[value='Check out'], input[value='Check Out']").prop('disabled', true);
                        
                  }
            })  
          },
          termsRequired:function(){
            if(this.data.check_terms=="required"){
                if($(".shopify-payment-button").parents("form").find(".zooomyagreetoterms").length>0){
                    $('.shopify-payment-button>div').css( 'pointer-events', 'none' );
                }  
                
               return true;
            }else{
                return false;
            }
          },
          otherPaymentPoint:function(){
            if($(".shopify-cleanslate li").length>0){
               $('.shopify-cleanslate li>div,.shopify-cleanslate li iframe[class*="paypalLight"]').css( 'pointer-events', 'none' );
                zooomyFun.clickShopifyPayment();
            }
            

          },
           getTermDiv:function(){
              if($(".zooomyagreetoterms").length==0)  {
               
                    return '<div class="zooomyagreetoterms"></div>'
              } 
              return ''; 
          },
          addTerms:function(item){
            this.data=item;
            if(this.data.enable_check=="enable"){

                  this.checkClass()
                  let getUrl=window.location.pathname;
                    
                    // $("#cart-notification-form,.drawer__content form,.cart__foot-inner em,.cart__footer .cart__checkout-wrapper,.mini-cart__button-container").prepend('<div class="zooomyagreetoterms"></div>');
                    // if($(".zooomyagreetoterms").length==0){
                    //     $(".cart__policies,.totals,.subtotal-row,.drawer__footer>.cart__item-sub,.cart-recap__notices,.quick-cart__total,#cart-form .subtotal,.Drawer__Footer .Cart__Taxes,.cart-drawer__disclaimerxx").after(this.getTermDiv());
                    // }
                        
                    
                    let zooStyle=`<style>
                                .zooomyagreetoterms{text-align:right}
                                .zooomyagreetoterms>input{width:${item.checkbox_size}!important;height:${item.checkbox_size}!important};
                                .zooomyagreetoterms span{color:${item.checkbox_font_color};font-size:${item.checkbox_font_size};}
                                .zooomyagreetoterms span a{color:${item.click_here_text_color};}
                                ${this.data.user_added_css}
                                ${this.data.custom_css}
                                </style>`;
                    $("body").append(zooStyle);
                   setTimeout(function(){
                       // $(".ajax-cart__buttons").prepend('<div class="zooomyagreetoterms"></div>');
                         zooomyFun.addCheckbox();
                         
                   },1000)
                   
                 
                   if(getUrl.includes("/cart")){
                       if(Shopify.theme.name.includes("Warehouse")){

                       }else{

                            $(".zooomyagreetoterms").css({'text-align':'right'});
                            let zooStyle=`<style>
                                .zooomyagreetoterms input{width:auto};
                                </style>`;
                                $("body").append(zooStyle);
                       }

                    
                
                    $(".cart__summary [name=checkout]").parent().before(this.getTermDiv());

                        
                      
                   }


                   
                   
                   this.termsRequired();
                   this.buyNow();
                   this.buttonClick();
                   this.termsChecked();
                   this.addCheckbox();
                  
                   setTimeout(function(){ 
                     zooomyFun.otherPaymentPoint()
                   },3000)
                  
             }  
          },
          checkClass:function(){
           

          }
          ,init:function(items){
           
              this.addTerms(items)
          }
        }
        
  
  }

  
  function reqJquery() {
    if ("undefined" == typeof jQuery || !jQuery || (1 === parseInt(jQuery.fn.jquery) && 11 > parseFloat(jQuery.fn.jquery.replace(/^1\./, "")))) {
        var o = document.getElementsByTagName("head")[0],
            t = document.createElement("script");
        (t.src = "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.1/jquery.min.js"),
            (t.type = "text/javascript"),
            (t.onload = t.onreadystatechange = function () {
                t.readyState ? ("complete" !== t.readyState && "loaded" !== t.readyState) || ((t.onreadystatechange = null), zooomyTC(jQuery.noConflict(!0))) : zooomyTC(jQuery.noConflict(!0));
            }),
            o.appendChild(t);
    } else zooomyTC(jQuery);
}
typeof meta !="undefined"  && "product" == meta.page.pageType ? setTimeout(reqJquery, 2e3) : reqJquery();